import React, { FC } from "react";

import MaterialListItemButton, { ListItemButtonProps } from "@mui/material/ListItemButton";

export const ListItemButton: FC<ListItemButtonProps> = (props) => (
  <MaterialListItemButton {...props}>
    {props.children}
  </MaterialListItemButton>
);
